import { Toast } from 'vant'
import { Auth, Mfe } from '@nio-pow/mfe-vue3'
import { AUTH_WHITELIST, isPurePagePath } from '@/utils/constants'

export default function beforeEach(to: any, _from: any, next: any) {
  const isMicroApp = Mfe.findMicroApp(to.path)
  const newTo = to
  const { auth } = newTo.meta
  newTo.meta.isMicroApp = isMicroApp
  newTo.meta.purePage = isPurePagePath(to.path)

  if (AUTH_WHITELIST.includes(to.path)) {
    // 白名单页面，隐藏 loading，且直接放行
    Toast.clear()
    next()
  } else if (!auth || Auth.hasPermission(auth) || isMicroApp) {
    // 无需权限 或 为子应用页面，则直接放行
    if (newTo.meta.title) document.title = newTo.meta.title
    next()
  } else {
    next({ path: '/error' })
  }
}
